export default "__VITE_ASSET__0bdd6ff0__"